/*PROJECT CREATOR*/
Vue.component('projectcreator',{
    template:'#projectcreator-template',
    data:function(){
        return{
            client: [],
            project:{
                assignees:[]
            },
            backupRecord:[],
            brands:[],
            subBrands:[],
            activeClient:'',
            activeBrand:'',
            activeBrandId:'',
            activeSubBrand:'',
            activeSubBrandId:'',
            projectName:'',
            projectDeadLine:'',
            projectStart:'',
            projects:'',
            recentProjectNumbers:[],
            completionMonth:'',
            briefTemplates:[],
            activeDivision:[],
            activeDivisionId:'',
            dropZoneInstance:'',
            dropZoneFiles:[],
            clients: [],
            maxFileSize: 80 /* MB */,
			deadline:'',
			divisions: [],
            project_stages:[
            ]
        };
    },
    created:function(){
        activeInstance = this;
        activeInstance.getBriefTemplates();
        activeInstance.getActiveDivisions();
        activeInstance.getClients();

        axios.get(baseURL + '/ajax/auto_assignees/list').then(function(auto_assingees_response) {

            var auto_assignees = auto_assingees_response.data;
            for (a = 0, a_l = auto_assignees.length; a < a_l; a ++) {
                activeInstance.project.assignees.push(auto_assignees[a].user);
            }
        });

        setTimeout(function(){

            var token = $("meta[name='csrf-token']").attr('content');
            console.log('token:');
            console.log(token);


            setTimeout(function(){
                $(function () {
                    $('#datetimepicker6').datetimepicker({
                        format: 'YYYY-MM-DD HH:00',
                        locale: 'hu',
                    });
                });
            },300);

            // Dropzone class:
            activeInstance.dropZoneInstance = $("#dropzone").dropzone({
                url: baseURL+'/admin/project/brief/file_upload',
                addRemoveLinks: true,
                maxFilesize: activeInstance.maxFileSize,
                headers: {
                    'X-CSRF-TOKEN': token
                },
                addedfile: function(file) {
                    console.log('e');
                    // Now attach this new element some where in your page
                },
                init: function() {
                    this.on("addedfile", function(file, response) {

                        // PREVENT FILE DUPLICATES
                        if (this.files.length) {
                            var _i, _len;
                            for (_i = 0, _len = this.files.length; _i < _len - 1; _i++) // -1 to exclude current file
                            {
                                if(this.files[_i].name === file.name && this.files[_i].size === file.size && this.files[_i].lastModifiedDate.toString() === file.lastModifiedDate.toString())
                                {
                                    errorNotification("Ezt a file-t már feltöltötted a kommenthez.");
                                    return false;
                                }
                            }
                        }

                        if (file.size > activeInstance.maxFileSize * 1000000) {
                            errorNotification("Túl nagy file. Megengedett maximális méret: " + activeInstance.maxFileSize + "MB");
                            return;
                        }

                        console.log(response);
                        var fileRecord = {};
                        fileRecord.name = file.name;
                        fileRecord.progress = 0;
                        fileRecord.bytesSent = 0;
                        fileRecord.file = file;
                        fileRecord.file_record_id = '';
                        activeInstance.dropZoneFiles.push(fileRecord);
                    });
                    this.on("success", function(file, response) {
                        console.log('succesfile:');
                        console.log(response);
                        $.each(activeInstance.dropZoneFiles,function(index,dropZoneFile){
                            if(dropZoneFile.name==file.name){
                                dropZoneFile.file_record_id=response;
                            }
                        });
                    });
                    this.on("uploadprogress", function(file) {
                        $.each(activeInstance.dropZoneFiles,function(index,dropZoneFile){
                            if(dropZoneFile.name==file.name){
                                dropZoneFile.progress=file.upload.progress;
                                dropZoneFile.bytesSent=file.upload.bytesSent;
                            }
                        });
                        console.log(file);
                        console.log(file.name);
                        console.log(file.upload.progress);
                        console.log(file.upload.bytesSent);
                    });
                }
            });
            $('#dropzone').addClass('dropzone');
        },200);

    },
    events: {
        //ON CLIENT SELECTION
        'autocomplete-result:selected': function(data){
            console.log(data);

            activeInstance.activeClient = data;
            activeInstance.getClientBrands(data.id);
        },

        //ON USER SELECTION -> ADD USER (IF NOT ALREADY ASSIGNED)
        'autocomplete-user:selected': function(data){

            var found = false;

            $.each(activeInstance.project.assignees,function(index,assignee){
                if(data.id==assignee.id){
                    found = true;
                }
            });

            if(found==false) {
                activeInstance.project.assignees.push(data);
            }

            setTimeout(function() {
                $('#assignees').val('');
            },60);

        }
    },
    methods:{
        createStage:function() {
            vex.dialog.open({
                message: 'Az új szakasz adatai:',
                input:[
                    '<div class="vex-custom-field-wrapper">',
                        '<label for="title">Megnevezés:</label>',
                        '<div class="vex-custom-input-wrapper title">',
                            '<input name="title" type="text" />',
                        '</div>',
                    '</div>',
                    '<div class="vex-custom-field-wrapper">',
                        '<label for="deadline">Határidő</label>',
                        '<div class="vex-custom-input-wrapper deadline">',
                    '<div class="input-group date" id="datetimepicker7">',
                    '<input type="text" class="form-control disabled" id="field_date" name="deadline" />',
                    '<span class="input-group-addon">',
                    '<span class="glyphicon glyphicon-calendar"></span>',
                    '</span>',
                    '</div>',
                        '</div>',
                    '</div>'

                ].join(''),
                callback: function (data) {
                    if (!data) {
                        return console.log('Cancelled')
                    }


                    var nextIndex = activeInstance.project_stages.length+1;

                    var record = {
                        index:nextIndex,
                        title:data.title,
                        deadline:data.deadline
                    };

                    console.log(record);

                    activeInstance.project_stages.push(record);
                },
                afterOpen:function(){

                    var now= moment();
                    console.log(now);

                    //INITIATE DATETIMEPICKER
                    $('#datetimepicker7').datetimepicker({
                        format: 'YYYY-MM-DD',
                        locale: 'hu',
                        defaultDate: now.format("YYYY-MM-DD"),
                        minDate: now.format("YYYY-MM-DD")

                    });
                }
            })
        },
        editStage:function(stage) {
            vex.dialog.open({
                message: stage.title+':',
                input:[
                    '<div class="vex-custom-field-wrapper">',
                    '<label for="title">Megnevezés:</label>',
                    '<div class="vex-custom-input-wrapper title">',
                    '<input name="title" type="text" value="'+stage.title+'" />',
                    '</div>',
                    '</div>',
                    '<div class="vex-custom-field-wrapper">',
                    '<label for="deadline">Határidő</label>',
                    '<div class="vex-custom-input-wrapper deadline">',
                    '<div class="input-group date" id="datetimepicker7">',
                    '<input type="text" class="form-control disabled" id="field_date" value="'+stage.deadline+'" name="deadline" />',
                    '<span class="input-group-addon">',
                    '<span class="glyphicon glyphicon-calendar"></span>',
                    '</span>',
                    '</div>',
                    '</div>',
                    '</div>'

                ].join(''),
                callback: function (data) {
                    if (!data) {
                        return console.log('Cancelled')
                    }

                    stage.deadline=data.deadline;
                    stage.title=data.title;

                },
                afterOpen:function(){

                    var now= moment();
                    console.log(now);

                    //INITIATE DATETIMEPICKER
                    $('#datetimepicker7').datetimepicker({
                        format: 'YYYY-MM-DD',
                        locale: 'hu',
                        defaultDate: now.format("YYYY-MMM-DD"),
                        minDate: now.format("YYYY-MMM-DD")

                    });
                }
            })
        },
        destroyStage:function(stage){

            vex.dialog.confirm({
                message: 'Biztosan törlöd a szakszt? ('+stage.title+')',
                callback: function (value) {
                    console.log('e');
                    console.log(value);
                    if(value==true){
                        console.log(stage);
                        activeInstance.project_stages.$remove(stage);
                    }
                }
            })


        },
        onClientChange: function(data){
            console.log(data);

            //activeInstance.activeClient = data;
            activeInstance.getClientBrands(activeInstance.activeClient.id);
        },
        getClients: function() {
            showLoadingOverlay();
            axios.get(baseURL+'/api/client/list/all')
                .then(function (response) {
                    $('body').LoadingOverlay("hide");
                    activeInstance.clients = response.data;
                })
                .catch(function (error) {
                    $('body').LoadingOverlay("hide");
                    console.log(error);
                });
        },
        deleteFileAttachment:function(file){
            showLoadingOverlay();
            axios.post(baseURL+'/admin/project/brief/remove_uploaded_file_id', {
                file_record_id: file.file_record_id
            }).then(function (response) {
                $('body').LoadingOverlay("hide");
                activeInstance.dropZoneFiles.$remove(file);
            })
                .catch(function (error) {
                    $('body').LoadingOverlay("hide");
                    console.log(error);
                });
        },
        importDivisionBriefTemplate:function(){
            var division_id = activeInstance.activeDivisionId;
            $.each(activeInstance.briefTemplates,function(index,division){
                console.log(division);
                if(division.id == division_id){
                    activeInstance.activeDivision = division;
                }
            });
        },
        getBriefTemplates:function(){
            showLoadingOverlay();
            axios.get(baseURL+'/api/division_brief_templates?type=project')
                .then(function(response){
                    $('body').LoadingOverlay("hide");
                    activeInstance.briefTemplates = response.data;
                });
		},
		getActiveDivisions:function(){
            showLoadingOverlay();
            axios.get(baseURL+'/api/divisions/get/active')
                .then(function(response){
                    $('body').LoadingOverlay("hide");
                    activeInstance.divisions = response.data;
                });
        },
        removeAssignee:function(assignee){
            activeInstance.project.assignees.$remove(assignee);
        },
        loadProjectDetails:function(){

            showLoadingOverlay();
            Vue.http.get(baseURL + '/api/project/list/one/'+activeInstance.project_id,function(response){
                $('body').LoadingOverlay("hide");

                response.start= response.start.substring(0,10);
                response.deadline= response.deadline.substring(0,10);
                activeInstance.project = response;

                activeInstance.activeClient = response.client;
                activeInstance.getClientBrands();
                activeInstance.activeBrand = response.brand;
                activeInstance.activeSubBrand = response.sub_brand;
                activeInstance.activeBrandId=response.brand_id;
                activeInstance.activeSubBrandId=response.sub_brand_id;

                $('#clientsearchfield').val(activeInstance.project.client.name);

                activeInstance.$http.get(baseURL+'/api/sub_brand/list/brand/'+activeInstance.activeBrand.id).then(function(response){
                    activeInstance.subBrands = response.data;

                    activeInstance.activeBrandId = $(event.target).val();
                    $.each(activeInstance.subBrands, function(index,sub_brand){
                        console.log('searching...');

                        if(sub_brand.id==activeInstance.activeSubBrandId){
                            console.log('found...');
                            activeInstance.activeSubBrand = sub_brand;

                        }
                    });

                }).bind(this);
            });
        },
        getAllProjectsForCurrentYear:function(){
            showLoadingOverlay();
            Vue.http.get(baseURL + '/api/projects/list/all_for_current_year', function(response){
                $('body').LoadingOverlay("hide");
                activeInstance.projects = response;
            });
        },
        edit:function(project){
            location.href = baseURL+'/admin/project/edit/'+project.id;
        },
        destroy:function(project){
            bootbox.confirm('Biztosan el akarod távolítani ezt a céget?', function(value){
                if(value!=null){
                    showLoadingOverlay();
                    Vue.http.post(baseURL+'/admin/project/destroy',{project:project}).then(function(response){
                        $('body').LoadingOverlay("hide");
                        successNotification('A projekt törölve.');
                        activeInstance.list.$remove(project);
                    });
                }
            });
        },
        //GET BRANDS BELONGS TO A CLIENT
        getClientBrands:function(){
            activeInstance.$http.get(baseURL+'/api/brand/list/client/'+activeInstance.activeClient.id).then(function(response){
                activeInstance.activeBrand={};
                activeInstance.activeSubBrand={};
                activeInstance.activeBrandId=-1;
                activeInstance.brands = response.data;

/*
                if (response.data.length == 1) {
                    setTimeout(function() {
                        $("#brand_id option:first-child").prop('selected', true);

                        activeInstance.activeBrandId=response.data[0].id;
                        activeInstance.activeBrand=response.data[0];
                        
                        activeInstance.getBrandSubBrands({
                            event: {
                                target: $("#brand_id")
                            }
                        }, null);
                    }, 500);
                }
*/
            }).bind(this);
        },
        //GET SUB BRANDS BELONGS TO A BRAND
        getBrandSubBrands:function(event,data){

            activeInstance.activeSubBrand={};
            activeInstance.activeSubBrandId=-1;
            activeInstance.activeBrandId = $(event.target).val();

            $.each(activeInstance.brands, function(index,brand){
                console.log('searching...');

                if(brand.id==activeInstance.activeBrandId){
                    console.log('found...');
                    activeInstance.activeBrand = brand;
                }
            });

            activeInstance.$http.get(baseURL+'/api/sub_brand/list/brand/'+activeInstance.activeBrand.id).then(function(response){
                activeInstance.subBrands = response.data;
/*
                if (response.data.length == 1) {
                    setTimeout(function() {
                        $("#sub_brand_id option:first-child").prop('selected', true);
                        $("#sub_brand_id").change();
                    }, 500);
                    
                    //activeInstance.activeSubBrandId = response.data[0]['id'];
                    //activeInstance.activeSubBrand = response.data[0];
                }
                */
            }).bind(this);

        },
        setActiveSubBrand:function(event){

            var subBrandId = $(event.target).val();

            $.each(activeInstance.subBrands, function(index,sub_brand){
                console.log('searching...');

                if(sub_brand.id==subBrandId){
                    console.log('found...');
                    activeInstance.activeSubBrand = sub_brand;
                }
            });
        },

        create:function(){
            showLoadingOverlay();
            $('.error').removeClass('error');

            var files = jQuery.extend(true, {}, activeInstance.dropZoneFiles);

            $.each(files,function(index,file){
                delete file.file;
            });

            axios.post(baseURL+'/admin/project/create',{
                'name':activeInstance.project.name,
                'brand_id':activeInstance.activeBrandId,
                'sub_brand_id':activeInstance.activeSubBrandId,
                'client_id':activeInstance.activeClient.id,
                'assignees':activeInstance.project.assignees,
                'completion_month':parseInt(activeInstance.completionMonth),
                'division_id':activeInstance.activeDivisionId,
                'brief_data': activeInstance.activeDivision.brief_template,
                'files':files,
                'billing_type':activeInstance.project.billing_type,
                'deadline':activeInstance.deadline,
                'stages':activeInstance.project_stages
            })
                .then(function(response) {
                    $('body').LoadingOverlay("hide");
                    successNotification('Sikeres mentés');
                    //console.log(response);
                    location.href = baseURL+'/admin/project/'+response.data.project_id;
                })
                .catch(function (error, data) {
                    $('body').LoadingOverlay("hide");
                    $.each(error.response.data,function(key, value){
                        errorNotification(value);
                        console.log(key);
                        $('#'+key).addClass('error');
                    });
                    console.log(error.response.data);
                });
        }
    }
});
